<template>
    <v-container class="py-5">
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>

        <v-row>
            <v-col cols="12" md="4">
                <v-form @submit.prevent="register" ref="refRegister" lazy-validation>
                    <v-card :loading="loading">
                        <v-card-title>
                            {{ $t('Crear nuevo rol') }}
                        </v-card-title>
                        <v-card-text>
                            <!-- name -->
                            <v-text-field
                                :label="$t('Rol *')"
                                outlined
                                dense
                                v-model="form.name"
                                :rules="[rules.required]"
                                :error="errors['name'] ? true :false"
                                :error-messages="errors['name'] ? errors['name'][0] : ''"
                            ></v-text-field>
                            <!-- end name -->
                            <!-- role -->
                            <v-select
                                :items="itemPermissions"
                                item-text="description"
                                item-value="id"
                                :label="$t('Permisos *')"
                                outlined
                                multiple
                                chips
                                v-model="form.permissions"
                                :rules="[rules.required2]"
                                :error="errors['role'] ? true :false"
                                :error-messages="errors['role'] ? errors['role'][0] : ''"
                            ></v-select>
                            <!-- end role -->
                            <!-- sucursales -->
                            <v-select
                                :items="branches"
                                item-text="name_store"
                                item-value="id"
                                :label="$t('Sucursal *')"
                                outlined
                                multiple
                                chips
                                v-model="form.branch"
                                :rules="[rules.required2]"
                                :error="errors['branch'] ? true :false"
                                :error-messages="errors['branch'] ? errors['branch'][0] : ''"
                            ></v-select>
                            <!-- End sucursales -->
                            <!-- caja -->
                            <v-switch
                                v-model="form.openCash"
                                :false-value="0"
                                :true-value="1"
                                :label="$t('Apertura y cierre de caja')"
                            ></v-switch>
                            <!-- END caja -->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="error"
                                :disabled="loading"
                                @click="clearData"
                            >{{ $t('Cancelar') }}</v-btn>
                            <v-btn
                                type="submit"
                                color="primary"
                                :loading="loading"
                            >{{ $t('Registrar') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>

            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="blue-grey darken-4 white--text">
                        {{ $t('Lista de roles') }}
                        <v-spacer></v-spacer>
                        <form @submit.prevent="processSearch" class="d-flex align-center">
                            <v-text-field
                                v-model="txtSearch"
                                :label="$t('Buscar...')"
                                outlined
                                dense
                                hide-details
                                type="text"
                                dark
                                @keyup="processSearch"
                            ></v-text-field>
                            <v-btn
                                color="red"
                                icon
                                large
                                v-show="txtSearch !== ''"
                                @click="cleanSearch"
                                class="ml-2"
                            >
                                <v-icon dark>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </form>
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        {{ $t('Rol') }}
                                    </th>
                                    <th class="text-right text-uppercase">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in roleList" :key="index">
                                    <td>{{ index }}</td>
                                    <!-- <td>{{ item.name }}</td> -->
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="editRole(index)"
                                                    >
                                                        <!-- @click="editRole(item.id)" -->
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('Editar') }}</span>
                                            </v-tooltip>

                                            <v-tooltip top v-if="index != 'Administrador'">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="deleteRole(item.map(item => item.id))"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('Eliminar') }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <!-- <div class="text-right py-2" v-html="pageTable"></div>
                <v-pagination
                    v-model="page"
                    :length="totalPage"
                    :total-visible="5"
                    color="primary"
                    @input="changePage"
                    class="my-5"
                ></v-pagination> -->
            </v-col>
        </v-row>

        <!-- dialog edit -->
        <v-dialog
            v-model="dialogEdit"
            max-width="400px"
            scrollable
        >
            <v-form @submit.prevent="edit" ref="refEdit" lazy-validation>
                <v-card :loading="loading">
                    <v-card-title>
                        {{ $t('Editar rol') }}
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <!-- name -->
                        <v-text-field
                            :label="$t('Rol *')"
                            outlined
                            dense
                            v-model="form2.name"
                            :rules="[rules.required]"
                            :error="errors['name'] ? true :false"
                            :error-messages="errors['name'] ? errors['name'][0] : ''"
                        ></v-text-field>
                        <!-- end name -->
                        <!-- role -->
                        <v-select
                            :items="itemPermissions"
                            item-text="description"
                            item-value="id"
                            :label="$t('Permisos *')"
                            outlined
                            multiple
                            chips
                            v-model="form2.permissions"
                            :rules="[rules.required2]"
                            :error="errors['role'] ? true :false"
                            :error-messages="errors['role'] ? errors['role'][0] : ''"
                        ></v-select>
                        <!-- end role -->
                        <!-- sucursales -->
                        <v-select
                            :items="branches"
                            item-text="name_store"
                            item-value="id"
                            :label="$t('Sucursal *')"
                            outlined
                            multiple
                            chips
                            v-model="form2.branch"
                            :rules="[rules.required2]"
                            :error="errors['branch'] ? true :false"
                            :error-messages="errors['branch'] ? errors['branch'][0] : ''"
                        ></v-select>
                        <!-- End sucursales -->
                         <!-- caja -->
                         <v-switch
                            v-model="form2.openCash"
                            :false-value="0"
                            :true-value="1"
                            :label="$t('Apertura y cierre de caja')"
                        ></v-switch>
                        <!-- END caja -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text
                            @click="dialogEdit = false"
                            :disabled="loading"
                        >
                            {{ $t('Cancelar') }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            :loading="loading"
                            type="submit"
                        >
                            {{ $t('Actualizar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- end dialog edit -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            overlay: false,
            breadcrumbs: [
                {
                    text: 'Roles',
                    disabled: true,
                    href: '',
                }
            ],
            // form
            itemPermissions: [],
            form: {
                name: '',
                permissions: [],
                openCash: 0,
                branch: []
            },
            loading: false,
            // edit
            dialogEdit: false,
            form2: {
                id: '',
                name: '',
                permissions: [],
                openCash: 0,
                branch: []
            },
            // lista
            roleList: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            // validation
            rules: {
                required: v => !!v || 'El campo es obligatorio',
                required2: v => (v.length >= 1) || 'Debe contener al menos 1 elemento',
            },
            errors: {},
            // sucursales
            branches: []
        }
    },
    props: ['permissions', 'slug'],
    mounted() {
        this.itemPermissions = JSON.parse(this.permissions)
        this.getRoleList()

        this.getVisibleItems()
    },
    methods: {
        /**
         * User list
         */
         processSearch () {
            this.page = 1
            this.getRoleList()
        },
        changePage (event) {
            this.page = event;
            this.getRoleList()
        },
        cleanSearch () {
            if (this.txtSearch !== '') {
                this.roleList = []
                this.page = 1
                this.txtSearch = ''
                this.getRoleList();
            }
        },
        async getRoleList () {
            this.overlay = true
            await axios.get(`/admin/role-list?page=${this.page}&search=${this.txtSearch}&paginate=yes`)
            .then(response => {
                // console.log(response)
                this.roleList = response.data
                // this.roleList = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `Showing <strong>${response.data.from??0} - ${response.data.to??0}</strong> of a total of <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error del servidor, inténtalo de nuevo más tarde.'));
                }
                this.overlay = false
            })
        },
        // sucursales
        async getVisibleItems() {
            await axios.get(`/admin/visible-items/?slug=${this.slug}`)
            .then((response) => {
                // console.log(response);
                this.branches = response.data.branches
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * Register
         */
        async register () {
            if (this.$refs.refRegister.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.form.name)
                formData.append('permissions', JSON.stringify(this.form.permissions))
                formData.append('branch', JSON.stringify(this.form.branch))
                formData.append('open_cash', this.form.openCash)
                await axios.post('/admin/my-roles', formData)
                .then(response => {
                    // console.log(response)
                    if (response.data == 'ok') {
                        this.$alert('', this.$t('Registro exitoso.'), 'success', {confirmButtonText: this.$t('Continue')})
                        this.getRoleList()
                        // reset
                        this.clearData()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error del servidor, inténtalo de nuevo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },
        clearData() {
            this.$refs.refRegister.resetValidation()
            this.form = {
                name: '',
                permissions: [],
                openCash: 0
            }
        },

        /**
         * Editar
         */
        editRole (id) {
            var tmpData = this.roleList[id]

            this.form2.id = JSON.stringify(tmpData.map(item => JSON.parse(item.id)))
            this.form2.name = id
            this.form2.permissions = [...new Set((tmpData.map(item => JSON.parse(item.permissions))).flat())]
            this.form2.openCash = tmpData[0].open_cash
            this.form2.branch = tmpData.map(item => JSON.parse(item.store_id))

            this.dialogEdit = true
        },
        async edit () {
            if (this.$refs.refEdit.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.form2.name)
                formData.append('permissions', JSON.stringify(this.form2.permissions)) // 'permissions
                formData.append('open_cash', this.form2.openCash)
                formData.append('branch', JSON.stringify(this.form2.branch))
                formData.append('_method', 'PUT')

                await axios.post(`/admin/my-roles/${this.form2.id}`, formData)
                .then(response => {
                    //console.log(response)
                    if (response.data == 'ok') {
                        this.$alert('', this.$t('Datos actualizados con éxito.'), 'success', {confirmButtonText: this.$t('Continue')})
                        this.getRoleList()
                        this.dialogEdit = false
                        // reset
                        this.$refs.refEdit.resetValidation()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error del servidor, inténtalo de nuevo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },

        /**
         * Delete
         */
        deleteRole (ids) {
            this.$confirm(
                this.$t('Se eliminará permanentemente del sistema'),
                this.$t('¿Eliminar rol?'),
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Continuar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/my-roles/${JSON.stringify(ids)}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', this.$t('Rol eliminado exitosamente.'), 'success', {confirmButtonText: this.$t('Continue')})
                            this.getRoleList()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.data == 'exists') {
                            this.$alert('El rol tiene usuarios asociados.');
                        }
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert(this.$t('Error del servidor, inténtalo de nuevo más tarde.'));
                        }
                    })
                }
            });
        },
    }
}
</script>